<template>
    <div class="checkbox">
        <label>
            <input type="checkbox" v-bind="$attrs" />
            <i></i>
            <slot></slot>
        </label>
    </div>
</template>

<script src="./app-checkbox.ts"></script>
